import { useBankProfile } from '@contexts/BankProfileContext';
import apiClient from '@services/apiClient';
import { useMutation } from '@tanstack/react-query';

interface ApplicationUrlResponse {
	redirect_url: string;
}

export const useApplicationUrl = () => {
	const { selectedProfile } = useBankProfile();

	return useMutation({
		mutationKey: ['application-url', selectedProfile?.id],
		mutationFn: async (): Promise<ApplicationUrlResponse> => {
			const response = await apiClient.post(
				`/profiles/${selectedProfile?.id}/odd/start`,
				undefined,
				{
					withCredentials: true,
				},
			);
			const url = response.data.redirect_url as string;
			return { redirect_url: url.startsWith('https://') ? url : `https://${url}` };
		},
	});
};
